/* Leaflet solo dove c'e' davvero una mappa.
 *
 * Importato staticamente costava ~146 KB di JS piu' 11 KB di CSS scaricati,
 * parsati ed eseguiti su OGNI pagina del sito. Di mappe ce n'e' una sola, su
 * /contatti (piu' quelle di sedi e promozioni, quando ci sono).
 *
 * Le view che disegnano una mappa avvolgono il loro codice in
 * window.loadLeaflet().then(function (L) { ... }).
 */
let leafletPromise = null;

window.loadLeaflet = function () {
    if (!leafletPromise) {
        leafletPromise = Promise.all([
            import("leaflet"),
            import("/node_modules/leaflet/dist/leaflet.css"),
        ]).then(([module]) => {
            const L = module.default ?? module;
            window.leaflet = L;
            // Il bundle popola anche window.L: il codice esistente che usa la
            // globale continua a funzionare senza modifiche.
            window.L = window.L || L;
            return window.L;
        });
    }

    return leafletPromise;
};
